import { render } from "./PortfelIcon.vue?vue&type=template&id=4cabad86&ts=true"
import script from "./PortfelIcon.vue?vue&type=script&lang=ts"
export * from "./PortfelIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__